import { useSpectrumThemeProvider } from "../../theme/index.js";
import { PICKER_ITEM_HEIGHTS } from "../../UIConstants.js";
/**
 * Get Picker Item height for current scale.
 * @returns Picker Item height
 */
export function usePickerItemScale() {
  var _useSpectrumThemeProv = useSpectrumThemeProvider(),
    scale = _useSpectrumThemeProv.scale;
  var itemHeight = PICKER_ITEM_HEIGHTS[scale];
  return {
    itemHeight
  };
}
export default usePickerItemScale;
//# sourceMappingURL=usePickerItemScale.js.map